import React, { useState, useEffect } from "react";
import axios from "axios";

const AppContext = React.createContext();

const usernameRegExp    = new RegExp(/^[a-zA-Z]{5,}$/);
const emailRegExp       = new RegExp(/^[a-zA-Z0-9#%&$_!.?]{5,}@[a-z0-9]{3,}\.[a-z0-9]{2,}$/);
const passwordRegExp    = new RegExp(/^[a-zA-Z0-9!@#$%^&*_.?]{8,}$/);
const phoneNumberRegExp = new RegExp(/^[0-9]{4}-[0-9]{7}$/);
const CNICnumberRegExp  = new RegExp(/^[0-9]{5}-[0-9]{7}-[0-9]{1}$/);

const regExpchecker = (type, input) => {
  switch (type) {
    case "username":
      if (!usernameRegExp.test(input))
        return "Username must be at least 5 characters long and contain only letters";
      break;
    case "email":
      if (!emailRegExp.test(input))
        return "Email must be in the format: john@example.com";
      break;
    case "password":
      if (!passwordRegExp.test(input))
        return "Password must be at least 8 characters long and can contain letters, numbers, and special characters";
      break;
    case "phoneNumber":
      if (!phoneNumberRegExp.test(input))
        return "Phone number must be in the format: 0300-1234567";
      break;
    case "CNICnumber":
      if (!CNICnumberRegExp.test(input))
        return "CNIC number must be in the format: 12345-1234567-1";
      break;
    default:
      return "Unknown field type";
  }
  return null;
};

// ✅ localStorage se ID safely parse karo
const getStoredId = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return (
      parsed?.id            ||
      parsed?.donor?.id     ||
      parsed?.donor_id      ||
      parsed?.receiver?.id  ||
      parsed?.receiver_id   ||
      null
    );
  } catch {
    return null;
  }
};

export const AppProvider = ({ children }) => {
  const [baseUrl, setBaseUrl] = useState("https://sdms.btsportfolio2026.com/backend/public/api");
  //const [baseUrl, setBaseUrl] = useState("http://localhost:8000/api");

  // ✅ NGO ID
  const [loggedInNgoId, setLoggedInNgoId] = useState(() => getStoredId("loggedInNgo"));
  const storeLoggedInNgoId = (id) => setLoggedInNgoId(id);

  // ✅ Admin ID
  const [loggedInAdminId, setLoggedInAdminId] = useState(() => getStoredId("loggedInAdmin"));
  const storeLoggedInAdminId = (id) => setLoggedInAdminId(id);

  // ✅ Donor ID
  const [loggedInDonorId, setLoggedInDonorId] = useState(() => getStoredId("loggedInDonor"));
  const storeLoggedInDonorId = (id) => setLoggedInDonorId(id);

  // ✅ Receiver ID
  const [loggedInReceiverId, setLoggedInReceiverId] = useState(() => getStoredId("loggedInReceiver"));
  const storeLoggedInReceiverId = (id) => setLoggedInReceiverId(id);

  // ============================================================
  // ✅ STALE ID GUARD
  // Jab bhi app load ho, backend se confirm karo ke stored
  // receiver_id / donor_id abhi bhi database mein exist karti hai.
  // Agar nahi karti (e.g. table reset/migrate ho gayi thi), to
  // us role ka localStorage clear kar do taake FK errors na aayen
  // aur user ko dobara login karna pade.
  // ============================================================
  useEffect(() => {
    const validateReceiver = async () => {
      if (!loggedInReceiverId) return;
      try {
        const res = await axios.get(`${baseUrl}/receiver/blood/viewRequestsByReceiver/${loggedInReceiverId}`);
        // agar backend "not found" jaisa kuch return kare to yahan handle karo
        if (res.data && res.data.success === false) {
          clearReceiverSession();
        }
      } catch (err) {
        // agar 404/500 aaye validation endpoint na hone ki wajah se, ignore karo
        // (ye sirf ek soft-check hai, hard fail nahi karna)
      }
    };
    validateReceiver();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const clearReceiverSession = () => {
    localStorage.removeItem("loggedInReceiver");
    localStorage.removeItem("receiveremail");
    localStorage.removeItem("receiverpassword");
    setLoggedInReceiverId(null);
  };

  const clearDonorSession = () => {
    localStorage.removeItem("loggedInDonor");
    localStorage.removeItem("donoremail");
    localStorage.removeItem("donorpassword");
    setLoggedInDonorId(null);
  };

  return (
    <AppContext.Provider
      value={{
        baseUrl,
        setBaseUrl,
        regExpchecker,

        // NGO
        loggedInNgoId,
        storeLoggedInNgoId,

        // Admin
        loggedInAdminId,
        storeLoggedInAdminId,

        // ✅ Donor
        loggedInDonorId,
        storeLoggedInDonorId,
        clearDonorSession,

        // ✅ Receiver
        loggedInReceiverId,
        storeLoggedInReceiverId,
        clearReceiverSession,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;